import { render, staticRenderFns } from "./EvaluationComP.vue?vue&type=template&id=0ba3b3c8"
import script from "./EvaluationComP.vue?vue&type=script&lang=js"
export * from "./EvaluationComP.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&scope=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports